module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-8-72a58aad5bbf8e35a1929673c66d5dd0.jpg";